export default __webpack_public_path__ + "static/media/bouquet-icon.1b158a16.svg";